import {Item} from '../lookups/item';
import {Entity} from '../base/entity';
import {DocumentItemSerial} from './document-item-serial';

export class DocumentItem extends Entity {

  public static readonly TABLENAME = 'document_item';

  public static readonly DOCUMENT_ID = 'document_id';
  public static readonly ITEM_ID = 'item_id';
  public static readonly QUANTITY = 'quantity';
  public static readonly PRICE_PER_UNIT = 'price_per_unit';
  public static readonly VAT_PER_UNIT = 'vat_per_unit';
  public static readonly DISCOUNT_PERCENT = 'discount_percent';
  public static readonly DISCOUNT = 'discount';
  public static readonly PRICE_DIFFERENCE_PERCENT = 'price_difference_percent';
  public static readonly PRICE_DIFFERENCE = 'price_difference';
  public static readonly VARIABLECOST_PERCENT = 'variablecost_percent';
  public static readonly VARIABLECOST = 'variablecost';
  public static readonly PP = 'pp';
  public static readonly VAT = 'vat';
  public static readonly PRICE = 'price';
  public static readonly COST_LOCATION = 'cost_location';
  public static readonly COST_ITEM = 'cost_item';
  public static readonly CHART_ACCOUNT_ID = 'chart_account_id';
  public static readonly VAT_ID = 'vat_id';
  public static readonly SORT = 'sort';
  public static readonly CREATED_AT = 'created_at';
  public static readonly UPDATED_AT = 'updated_at';
  public static readonly DELETED_AT = 'deleted_at';
  public static readonly CONTRACT_ID = 'contract_id';
  public static readonly PRICE_WITH_VAT = 'price_with_vat';
  public static readonly STOCK_PRICE = 'stock_price';

  item: Item;
  serialNumbers: DocumentItemSerial[];

  documentId: string;
  itemId: string;
  quantity: number;
  pricePerUnit: number;
  vatPerUnit: number;
  discountPercent: number;
  discount: number;
  priceDifferencePercent: number;
  priceDifference: number;
  variablecostPercent: number;
  variablecost: number;
  pp: number;
  vat: number;
  price: number;
  costLocation: string;
  costItem: string;
  chartAccountId: number;
  vatId: number;
  sort: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  contractId: string;
  priceWithVat: number;
  stockPrice: number;
  hasContractItem: number;
}
